import React from 'react';
const pains = ['Me dijeron que tengo el azúcar alta pero nadie me explicó qué eso le hace a mi corazón, mis ojos o mis riñones.', 'Tomo el medicamento. Hago lo que me dicen. Pero sigo sin entender si realmente está funcionando.', 'Busco información y todo está en inglés o tan técnico que no puedo entender nada.', 'Tengo miedo. Pero no sé exactamente a qué. Y eso es lo peor de todo.', 'Me preocupa mi familia. Si yo no entiendo esto, ¿cómo los voy a proteger a ellos?', 'Siento que el médico no tiene tiempo de explicarme. Salgo con más preguntas que respuestas.'];
export function PainPoints() {
  return <section className="py-20 md:py-28 px-4 bg-dark-secondary" data-id="element-547">
      <div className="max-w-content mx-auto" data-id="element-548">
        <div className="text-center mb-16" data-id="element-549">
          <span className="inline-block font-mono text-[11px] text-gold uppercase tracking-[0.2em] mb-4" data-id="element-550">
            ¿TE IDENTIFICAS?
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-cream leading-tight max-w-2xl mx-auto" data-id="element-551">
            Esto es lo que sientes cuando nadie te explica lo que está pasando
            dentro de ti
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-552">
          {pains.map((pain, idx) => <div key={idx} className="bg-dark-card border-l-[3px] border-gold rounded-lg p-6 md:p-8 relative group hover:-translate-y-1 transition-transform duration-300" data-id="element-553">
              <span className="absolute top-4 left-4 font-serif text-6xl text-gold/20 leading-none select-none pointer-events-none group-hover:text-gold/30 transition-colors" data-id="element-554">
                "
              </span>
              <p className="font-serif italic text-cream text-[17px] leading-relaxed relative z-10 mt-4" data-id="element-555">
                {pain}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-556">
          <p className="font-serif italic text-cream text-lg md:text-xl" data-id="element-557">
            "Si te reconociste en aunque sea uno, este libro fue escrito
            exactamente para ti."
          </p>
        </div>
      </div>
    </section>;
}